
export const id = {
  menu: {
    dashboard: 'Dasbor',
    projects: 'Proyek',
    teams: 'Tim',
    schedule: 'Jadwal',
    documents: 'Dokumen',
    reports: 'Laporan',
    settings: 'Pengaturan',
    info: 'Info',
    budget: 'Anggaran RAB',
    admin: 'Administrator',
    adminChat: 'Manajemen Chat',
    adminMembers: 'Manajemen Anggota'
  },
  settings: {
    title: 'Pengaturan',
    general: 'Umum',
    notifications: {
      title: 'Notifikasi',
      description: 'Kelola cara Anda menerima notifikasi',
      email: 'Notifikasi email',
      push: 'Notifikasi push',
      projectUpdates: 'Pembaruan proyek',
      taskReminders: 'Pengingat tugas'
    },
    data: {
      title: 'Data & Penyimpanan',
      description: 'Kelola preferensi data dan penyimpanan Anda',
      sync: {
        title: 'Sinkronisasi Otomatis',
        description: 'Sinkronkan data secara otomatis di seluruh perangkat'
      },
      cache: {
        title: 'Hapus Cache',
        description: 'Hapus data yang disimpan secara lokal'
      },
      localProjects: {
        title: 'Proyek Lokal',
        description: 'Proyek yang disimpan di perangkat ini'
      },
      export: {
        title: 'Ekspor Data',
        description: 'Unduh data proyek Anda'
      }
    },
    appearance: {
      title: 'Tampilan',
      description: 'Sesuaikan tampilan dan nuansa',
      darkMode: 'Mode gelap',
      minimalistTheme: 'Tema minimalis',
      sidebarType: 'Gaya sidebar',
      sidebarDescription: 'Pilih gaya navigasi yang Anda sukai',
      circular: 'Melingkar',
      compact: 'Kompak'
    },
    language: {
      title: 'Bahasa',
      description: 'Pilih bahasa yang Anda sukai',
      select: 'Pilih Bahasa',
      english: 'Bahasa Inggris',
      indonesian: 'Bahasa Indonesia',
      changeInfo: 'Perubahan bahasa akan diterapkan segera'
    }
  },
  info: {
    title: 'Informasi Proyek',
    about: 'Tentang Proyek Ini',
    version: 'Versi',
    lastUpdated: 'Terakhir Diperbarui',
    documentation: 'Dokumentasi',
    support: 'Dukungan',
    feedback: 'Kirim Masukan',
    developer: 'Pengembang'
  },
  common: {
    save: 'Simpan',
    cancel: 'Batal',
    delete: 'Hapus',
    edit: 'Edit',
    add: 'Tambah',
    remove: 'Hapus',
    confirm: 'Konfirmasi',
    loading: 'Memuat...',
    error: 'Error',
    success: 'Berhasil',
    warning: 'Peringatan',
    info: 'Informasi'
  }
};
